<ms-participant-image [participantImage]="participant.image" [sportId]="sportId" [showLogoColor]="showLogoColor" />

<div class="participant-group">
    <ms-scoreboard-participant
        class="participant-info"
        [showIndicator]="false"
        [event]="event"
        [participant]="participant"
        [isNewEDPScoreboard]="isNewEDPScoreboard" />
    @if (!isNewEDPScoreboard) {
        @if (redCardsCount >= 1) {
            <div class="red-card">
                @if (redCardsCount > 1) {
                    <span class="red-card-count">{{ redCards.length }}</span>
                }
            </div>
        }
    } @else {
        @if (redCardsCount >= 1) {
            @for (redCard of redCards; track $index) {
                <div class="red-card"></div>
            }
        }
    }
</div>
